<div class="app-mam-follower fx-panel">
  <div class="card bg-dark-lighter text-white">
    <div class="card-header">

    </div>
    <div class="card-body">
    <div class="p-15">
      <div class="row mb-1">
        <div class="col-md-2 col-xs-12">
          <span class="text mx-2">Categories
          </span>
          <div class="type-group">
            <p-dropdown
            [options]="selectedType"
            [(ngModel)]="condition.filter"
            optionValue="value"
            optionLabel="name"
            styleClass="form-control bg-dark"
            name="code"
            [autoDisplayFirst]="false"
            appendTo="body"
          ></p-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-xs-12" style="padding-left: 0;">
          <span class="text mx-2">
          </span>
          <div class="input-group search-group">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              placeholder="Search"
              [(ngModel)]="condition.keyword"
              (keyup)="search($event)"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="search('click')"
              >
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>

          </div>
        </div>
        <div class="col-12 col-md-7 mb-2 export-data align-items-center d-flex justify-content-end">
          <div>
            <div class=" d-inline-block">
              <span class="text mx-2">From
              </span>
              <div class="d-flex flex-column">
                <p-calendar
                  name="start_time"
                  [(ngModel)]="condition.from"
                  [required]="condition.to&&showError?true:false"
                  #from="ngModel"
                  [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                  [dateFormat]="'dd/mm/yy'"
                  [timeOnly]="false"
                  [showIcon]="true"
                  [showSeconds]="true"
                  [showTime]="true"
                  inputStyleClass="form-control"
                ></p-calendar>
              <small class="error-message text-red" *ngIf="showError && (from.errors?.required)" >
                Required
              </small>
              </div>
            </div>
            <div class="  d-inline-block ml-2" >
              <span class="text mx-2">To
              </span>
                <div class="d-flex flex-column">
                  <p-calendar
                    name="end_time"
                    [(ngModel)]="condition.to"
                    [required]="condition.from&&showError?true:false"
                    #to="ngModel"
                    [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                    [dateFormat]="'dd/mm/yy'"
                    [timeOnly]="false"
                    [showSeconds]="true"
                    [showIcon]="true"
                    [showTime]="true"
                    inputStyleClass="form-control"
                  ></p-calendar>
                  <small class="error-message text-red" *ngIf="showError && (to.errors?.required)" >
                    Required
                  </small>
                  <small class="error-message text-red" *ngIf="showError && condition.to<condition.from" >
                    To date must be later than From date
                  </small>
                </div>
            </div>
            <br>
            <span class="fs-12" style="font-style: italic;">*Please select period to export or skip it if you want to export all data.</span>

          </div>
          <button class="btn btn-primary ml-2 export-btn"
            pTooltip="Export Data"
            type="button"
            tooltipPosition="bottom"
            (click)="onExport()">
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
          <button
            class="btn btn-main ml-2"
            pTooltip="Refresh Data"
            tooltipPosition="bottom"
            type="button"
            (click)="onRefresh()"
          >
            <i class="fa fa-refresh"></i>
          </button>
          <!-- <fx-export-excel
            [totalRecord]="pageInfo.totalRecord"
            [pageSize]="pageInfo.pageSize"
            [currency]="currency"
            [params]="{
              q: condition.keyword,
              order_type: condition.order,
              order_by: getOrder(),
              kyc_status: condition.kycCode
            }"
          >
          </fx-export-excel> -->
        </div>
        <!-- <div class="col-md-6 col-xs-12" style="display: flex;justify-content: end;">
          <button
            class="btn btn-primary ml-2"
            pTooltip="Export Data"
            type="button"
            tooltipPosition="bottom"
            (click)="onExport()"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
            <button
            class="btn btn-main ml-2"
            pTooltip="Refresh Data"
            tooltipPosition="bottom"
            type="button"
            (click)="onRefresh()"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div> -->
      </div>

      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive">
            <table class="rox-table table-bordered bg-dark">
              <thead>
              <tr>
                <th class="sortable mw-100 text-center" (click)="sorting('id')">
                  No.
                  <i
                    class="fa fa-{{
                      condition.orderBy === 'id'
                        ? sort.id === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>
                <th class="sortable mw-100 text-center" (click)="sorting('username')">
                  User Name
                  <i
                  class="fa fa-{{
                    condition.orderBy === 'username'
                      ? sort.username === 'asc'
                        ? 'sort-asc'
                        : 'sort-desc'
                      : 'sort'
                  }}"
                ></i>
                </th>
                <th class="sortable mw-100 text-center" (click)="sorting('email')">
                  Email
                  <i
                    class="fa fa-{{
                      condition.orderBy === 'email'
                        ? sort.email === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>
                <th class="text-center">MT5 Account</th>
                <th class="text-center">MT5 Group</th>
                <th class="text-center">Master ID</th>
                <th class="text-center">Balance</th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="
                          let item of data
                            | paginate
                              : {
                                  id: 'mamFollower',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                };
                          let i = index
                        ">
                <td class="text-center">{{item.id}}</td>
                <td class="text-center">{{item.getUserName()}}</td>
                <td class="text-center">{{item.email}}</td>
                <td class="text-center">{{item.login}}</td>
                <td class="text-right group">
                  <div><span labelGroup="{{item.currentGroup}}" class="mr-15"></span></div>
                  <div><a
                    href="javascript:void(0)"
                    class="text-blue-lighter"
                    (click)="getMamFollowerInfo(item)"
                    data-bs-toggle="modal"
                    data-bs-target="#modalMamFollower"
                  ><i class="fa fa-edit mr-15" pTooltip="Select Group" tooltipPosition="bottom"></i></a></div>
                  <div style="min-width: 35px;"><i class="fa fa-window-close-o mr-15" *ngIf="item.isPam!==1" style="cursor: pointer;" aria-hidden="true" (click)="processCloseAll(item)" pTooltip="Close all positions" tooltipPosition="bottom"></i></div>
                </td>
                <!-- <td class="text-center">
                  <span pTooltip="Master Information
                                  Email: {{item.masterEmail}}" tooltipPosition="bottom"  tooltipStyleClass="customtooltip">{{item.masterId}}</span></td> -->
                                  <td class="text-center"><a
                                    href="javascript:void(0)"
                                    style="text-decoration: none"
                                    class="text-blue-lighter {{
                                      permission.allowCreating ? '' : 'ignore-click'
                                    }}"
                                    [fxPopoverTriggerFor]="popoverMasterIdInformation"
                                    [fxPopoverData]="item.masterEmail"
                                    >{{ item.masterId }}</a
                                  ></td>
                <td class="text-center" create-permission>
                  <a
                    href="javascript:void(0)"
                    class="text-blue-lighter"
                    (click)="getMamDetail(item)"
                  >View</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="mamFollower"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
        <div class="col-auto">
          <span class="data-info "
            >Total Records: {{ pageInfo.totalRecord }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade fx-modal" id="modalMamFollower">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" *ngIf="dataSelected">

        <!-- Modal Header -->
        <div class="modal-header">
          <!-- <h4 class="modal-title">
            {{dataSelected.email}}
            ({{dataSelected.getUserName()}})
          </h4> -->
          <!-- <button type="button" class="close" data-bs-dismiss="modal">&times;</button> -->
        </div>

        <!-- Modal body -->
        <div class="modal-body mb-3">
          <div class="row">
            <div class="col">
              <div class="col-3 mb-2">Group(s)</div>
              <div class="col-12 mb-2">
                <select style="color: #333 !important;" [(ngModel)]="conditionUpdate.group" class="form-control">
                  <option *ngIf="!conditionUpdate.group" value="">Select group</option>
                  <option *ngFor="let group of dataSelected.groups" [value]="group">
                    <span labelGroup="{{group}}"></span>
                  </option>
                </select>
              </div>
              <!-- <div class="col-12 mb-2">
                <input class="form-control" type="text" [(ngModel)]="conditionUpdate.group" readonly>
              </div> -->
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex justify-content-center mt-3">
            <button class="btn-outline-do" mat-button color="warn" (click)="processApply()">Apply</button>
            <button data-bs-dismiss="modal"  class="btn-outline-cancel ms-2 close" mat-button >Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <fx-popover #popoverMasterIdInformation (opened)="getMasterId($event)" [width]="'400px'">
    <ng-template fxPopoverContent let-data="data">
      <h5>Master Information</h5>
      <table class="rox-table table-bordered bg-dark">
        <tbody>
          <tr>
            <td>Email: {{selectedMasterId}}</td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </fx-popover>
</div>

